import makeStyles from 'e100-react-components/lib/styles/makeStyles';

const useStyles = makeStyles(({ palette, spacing, shape }) => ({
  chip: {
    borderRadius: shape.borderRadius / 2,
    padding: `${spacing(0.25)}px ${spacing(0.75)}px`,
    color: palette.primary.main,
    backgroundColor: palette.primary.light,
    fontSize: 11
  }
}));

export default useStyles;
